import React from 'react';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';

export default function TodayTask(props) {
  const { label, count, children } = props;

  const handleClick = () => {
    console.info('You clicked the Chip.');
  };

  return (
    <Badge
      color="secondary"
      badgeContent={count || 0}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      <Chip label={label} variant="outlined" onClick={handleClick} />
    </Badge>
  );
}
